var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomtype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_489870",
    clipPath: "url(#clip0_206_4122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2 15.2404V11.6C15.2 10.9384 14.6616 10.4 14 10.4H2.8C2.1384 10.4 1.6 10.9384 1.6 11.6V15.2404C0.6884 15.4264 0 16.2344 0 17.2V19.6V23.6C0 23.8208 0.1792 24 0.4 24H2C2.2208 24 2.4 23.8208 2.4 23.6V22.4H14.4V23.6C14.4 23.8208 14.5792 24 14.8 24H16.4C16.6208 24 16.8 23.8208 16.8 23.6V19.6V17.2C16.8 16.2344 16.1116 15.4264 15.2 15.2404ZM2.4 11.6C2.4 11.3796 2.5796 11.2 2.8 11.2H14C14.2204 11.2 14.4 11.3796 14.4 11.6V15.2H13.6V13.6C13.6 12.9384 13.0616 12.4 12.4 12.4H10C9.3384 12.4 8.8 12.9384 8.8 13.6V15.2H8V13.6C8 12.9384 7.4616 12.4 6.8 12.4H4.4C3.7384 12.4 3.2 12.9384 3.2 13.6V15.2H2.4V11.6ZM12.8 13.6V15.2H9.6V13.6C9.6 13.3796 9.7796 13.2 10 13.2H12.4C12.6204 13.2 12.8 13.3796 12.8 13.6ZM7.2 13.6V15.2H4V13.6C4 13.3796 4.1796 13.2 4.4 13.2H6.8C7.0204 13.2 7.2 13.3796 7.2 13.6ZM16 23.2H15.2V22C15.2 21.7792 15.0208 21.6 14.8 21.6H2C1.7792 21.6 1.6 21.7792 1.6 22V23.2H0.8V20H16V23.2ZM16 19.2H0.8V17.2C0.8 16.5384 1.3384 16 2 16H3.6H7.6H9.2H13.2H14.8C15.4616 16 16 16.5384 16 17.2V19.2Z",
    fill: "#202842"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.5996 15.2H17.9996C17.7788 15.2 17.5996 15.3792 17.5996 15.6V18.8V21.6H18.3996V19.2H23.1996V21.6H23.9996V18.8V15.6C23.9996 15.3792 23.8204 15.2 23.5996 15.2ZM23.1996 18.4H18.3996V16H23.1996V18.4Z",
    fill: "#202842"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.6 16.8H20V17.6H21.6V16.8Z",
    fill: "#202842"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.7795 11.8732L21.9795 9.47315C21.9247 9.30995 21.7723 9.19995 21.5999 9.19995H19.9999C19.8275 9.19995 19.6751 9.30995 19.6203 9.47355L18.8203 11.8736C18.7795 11.9956 18.8003 12.1296 18.8755 12.234C18.9507 12.3384 19.0715 12.4 19.1999 12.4H20.3999V13.6H19.5999V14.4H21.9999V13.6H21.1999V12.4H22.3999C22.5283 12.4 22.6491 12.3384 22.7243 12.2336C22.7995 12.1292 22.8199 11.9952 22.7795 11.8732ZM19.7547 11.6L20.2883 9.99995H21.3119L21.8451 11.6H19.7547Z",
    fill: "#202842"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.7636 5.2348L12.1636 0.0348C12.0592 -0.0116 11.9404 -0.0116 11.8364 0.0348L0.2364 5.2348C0.0924 5.2996 0 5.4424 0 5.6V10.4H0.8V5.8588L12 0.8384L23.2 5.8592V10.4H24V5.6C24 5.4424 23.9076 5.2996 23.7636 5.2348Z",
    fill: "#202842"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.7614 5.53355L13.9722 5.66635C13.991 5.77555 14.0002 5.88755 14.0002 5.99995C14.0002 7.10275 13.103 7.99995 12.0002 7.99995C10.8974 7.99995 10.0002 7.10275 10.0002 5.99995C10.0002 4.89715 10.8974 3.99995 12.0002 3.99995C12.229 3.99995 12.4538 4.03835 12.6674 4.11395L12.9338 3.35955C12.6342 3.25355 12.3202 3.19995 12.0002 3.19995C10.4562 3.19995 9.2002 4.45595 9.2002 5.99995C9.2002 7.54395 10.4562 8.79995 12.0002 8.79995C13.5442 8.79995 14.8002 7.54395 14.8002 5.99995C14.8002 5.84315 14.787 5.68635 14.7614 5.53355Z",
    fill: "#202842"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.517 3.31726L11.9998 5.83446L11.4826 5.31726L10.917 5.88286L11.717 6.68286C11.795 6.76086 11.8974 6.80006 11.9998 6.80006C12.1022 6.80006 12.2046 6.76086 12.2826 6.68286L15.0826 3.88286L14.517 3.31726Z",
    fill: "#202842"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_4122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomtype);
export default __webpack_public_path__ + "static/media/roomtype.a5accbad61d15eb828e1fa924534315e.svg";
export { ForwardRef as ReactComponent };